// extracted by mini-css-extract-plugin
module.exports = {"root":"split-section_root__sY2MY"};